// İt206 (2026-05-21) — Karargah onaylı Zebra ES5 polyfill enjeksiyonu.
// React import'undan ÖNCE polyfill yüklenmeli (modulü kullanan kod çalışmadan API'ler tanımlı olmalı).
// react-app-polyfill/ie11 → Promise, Object.assign, Array.from, Symbol minimal core.
// react-app-polyfill/stable → core-js stable (fetch, Map, Set, Array.includes, String.startsWith vb.)
// Zebra Android 4.4 KitKat (Chrome 30-50) bu API'leri yerel olarak tanımıyor → SyntaxError'lar buradan.
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

// ════════════════════════════════════════════════════════════════════════════════
// İt253 (2026-05-22) — KÜRESEL SUSTURUCU 3 KATMAN (Karargah talimat)
// ════════════════════════════════════════════════════════════════════════════════
// Katman 1: Cache katliamı — ServiceWorker unregister + Cache API temizliği.
// Katman 2: window.onerror + unhandledrejection — "Zebra/baglanti/surum"
//           kelimelerini içeren hataları SESSİZCE YUT (preventDefault + return true).
// Katman 3: index.html'de Cache-Control meta etiketleri (İt199'da kuruldu).
// ════════════════════════════════════════════════════════════════════════════════

// Katman 1 — Cache katliamı (her boot'ta zorla temizlik).
(function _it253_cacheKill() {
  try {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(function (regs) {
        regs.forEach(function (r) {
          try { r.unregister(); } catch (_) {}
        });
      }).catch(function () {});
    }
  } catch (_) {}
  try {
    if (typeof caches !== 'undefined' && caches && caches.keys) {
      caches.keys().then(function (names) {
        names.forEach(function (name) {
          try { caches.delete(name); } catch (_) {}
        });
      }).catch(function () {});
    }
  } catch (_) {}
})();

// Katman 2 — Küresel hata yutucu. Zebra/bağlantı/sürüm içeren hataları sustur.
// Saha komutanı ekranında teknik mesaj görmemeli; arka planda console.warn.
(function _it253_globalSilencer() {
  function _shouldSilence(msg) {
    if (!msg) return false;
    var s = String(msg).toLowerCase();
    return (
      s.indexOf('zebra') !== -1 ||
      s.indexOf('baglanti') !== -1 ||
      s.indexOf('bağlantı') !== -1 ||
      s.indexOf('surum') !== -1 ||
      s.indexOf('sürüm') !== -1 ||
      s.indexOf('version') !== -1
    );
  }

  // window.onerror — global JS error yakalama (synchronous errors).
  try {
    var _origOnError = window.onerror;
    window.onerror = function (message, source, lineno, colno, error) {
      try {
        var combined = (message || '') + ' ' + (error && error.message ? error.message : '');
        if (_shouldSilence(combined)) {
          try { console.warn('[İt253] silenced window.onerror:', combined); } catch (_) {}
          return true; // Zincirleme yayılmayı durdur, browser default UI'sını engelle.
        }
      } catch (_) {}
      if (typeof _origOnError === 'function') {
        try { return _origOnError.apply(this, arguments); } catch (_) {}
      }
      return false;
    };
  } catch (_) {}

  // addEventListener('error', ...) — capture phase, asset load + script error.
  try {
    window.addEventListener('error', function (event) {
      try {
        var msg = (event && event.message) || (event && event.error && event.error.message) || '';
        if (_shouldSilence(msg)) {
          if (typeof event.preventDefault === 'function') event.preventDefault();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          try { console.warn('[İt253] silenced error event:', msg); } catch (_) {}
          return true;
        }
      } catch (_) {}
    }, true);
  } catch (_) {}

  // unhandledrejection — Promise reject sonsuz rejection (Zebra async fetch fail vb.)
  try {
    window.addEventListener('unhandledrejection', function (event) {
      try {
        var reason = event && event.reason;
        var msg = '';
        if (reason) {
          msg = (reason.message ? String(reason.message) : '') + ' ' + (typeof reason === 'string' ? reason : '');
        }
        if (_shouldSilence(msg)) {
          if (typeof event.preventDefault === 'function') event.preventDefault();
          try { console.warn('[İt253] silenced unhandledrejection:', msg); } catch (_) {}
          return true;
        }
      } catch (_) {}
    });
  } catch (_) {}
})();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "./i18n"; // Initialize i18n

// Patch ResizeObserver to prevent harmless loop errors
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

// Suppress console errors for ResizeObserver
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop')
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Catch unhandled errors
window.addEventListener('error', (event) => {
  if (event.message.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

// Global img error handler — bozuk görsellerde fallback göster (image boyutunu korur)
document.addEventListener('error', (e) => {
  if (e.target.tagName === 'IMG') {
    const img = e.target;
    if (img.dataset.fallback) return;
    img.dataset.fallback = 'true';
    // Image'ın gerçek boyutunu al (display:none öncesi)
    const rect = img.getBoundingClientRect();
    const w = rect.width || img.offsetWidth || 48;
    const h = rect.height || img.offsetHeight || 48;
    img.style.display = 'none';
    const parent = img.parentElement;
    if (parent && !parent.querySelector('.img-fallback')) {
      // Image'ın class'larından layout/boyut class'larını kopyala (object-* hariç)
      const imgClasses = Array.from(img.classList || [])
        .filter(c => !c.startsWith('object-') && c !== 'cursor-pointer');
      const fallback = document.createElement('div');
      fallback.className = 'img-fallback flex items-center justify-center bg-slate-100 dark:bg-slate-700 flex-shrink-0 ' + imgClasses.join(' ');
      // Güvenlik: eğer imgClasses'ta boyut yoksa inline style ile image'ın ölçüsünü ver
      if (!imgClasses.some(c => /^w-/.test(c))) fallback.style.width = w + 'px';
      if (!imgClasses.some(c => /^h-/.test(c))) fallback.style.height = h + 'px';
      fallback.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-slate-400"><path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"></path><path d="M12 22V12"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><path d="m7.5 4.27 9 5.15"></path></svg>';
      parent.appendChild(fallback);
    }
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
